import Vue from 'vue';

export default {
  state: {
    portfolio_types: [],
  },
  getters: {
    portfolio_types(state) {
      return state.portfolio_types;
    },
    // eslint-disable-next-line
    portfolio_type: state => (id) => {
      return state.portfolio_types.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_PORTFOLIOS(state, payload) {
      state.portfolio_types = payload;
    },
  },
  actions: {
    GET_PORTFOLIOS(context) {
      return Vue.axios.get('filters/portfolio_types').then((response) => {
        context.commit('SET_PORTFOLIOS', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/portfolio_types.js